import { ChangeDetectionStrategy, Component, Input, OnInit, output, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { availibleFilters, FiltersConfig, ICustomFilter, SortOption, sortOptions, ListFilterBarOptions } from '../../models/filter.models';
import { MenuItem } from 'primeng/api';
import { OnActionEvent } from '../../models/pagination.abstract';

const DEFAULT_FILTERS: FiltersConfig = { filters: {}, page: 0, rowsPerPage: 10, sort: { _id: -1 } };
type actions = 'new' | 'edit' | 'delete' | 'changeView' | (string & {});
@Component({
  selector: 'dc-filter-bar',
  standalone: true,
  imports: [FormsModule, ButtonModule, DialogModule, SelectModule, MultiSelectModule, CalendarModule],
  templateUrl: './dc-list-filter-bar.component.html',
  styleUrl: './dc-list-filter-bar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DCFilterBarComponent implements OnInit {
  // Signal Inputs
  public readonly items = input<MenuItem[]>([]);
  public readonly options = input<ListFilterBarOptions>({ showCreateButton: true });
  // Inputs
  @Input() public customFilters: ICustomFilter[] = [];

  // Outputs
  public readonly onFilterAction = output<any>();
  public readonly onChangeSort = output<any>();
  public readonly onNew = output<any>();

  // Internal State
  public customFilterModels = [];

  ngOnInit(): void {
    console.log('customFilters', this.customFilters);

    if (this.customFilters.length > 0) {
      console.log('customFilters', this.customFilters);
      for (const filter of this.customFilters) {
        console.log('Deberia agregar un filtro nuevo', filter);
        // this.availibleFilters.push({
        //   name: filter.name,
        //   type: filter.type,
        //   options: filter.options,
        // });
      }
    }
  }

  public availibleFilters = availibleFilters;
  public sortOptions = sortOptions;

  public isSearchVisible = false;
  public isFilterVisible = false;
  public placeholder = '';

  public filter: FiltersConfig = { ...DEFAULT_FILTERS };

  selectedFilters: (typeof availibleFilters)[] = [];
  selectedSort: SortOption | null = null;
  dateRange: Date[] = [];

  public changeFilter(event) {
    console.log('Filter changed');
  }

  public changeSort(event) {
    console.log('Sort changed', event.value);
    this.onChangeSort.emit(event.value);
  }

  public createNew() {
    console.log('createNew from core components');
    this.onNew.emit('new');
  }

  public search(text: string = null): void {
    if (!text) {
      this.placeholder = '';
      this.clearFilters();
    } else {
      this.doItemAction({ action: 'search', item: text });
    }
    this.isSearchVisible = false;
  }

  clearFilters() {
    this.filter = { ...DEFAULT_FILTERS };
    this.doItemAction({ action: 'filterChange', item: this.filter });
  }

  applyFilters() {
    this.doItemAction({ action: 'filterChange', item: this.filter });
    this.isFilterVisible = false;
  }

  public doItemAction(filterEvent: OnActionEvent) {
    this.onFilterAction.emit(filterEvent);
  }
}
